/* Fiche produit Whoosh : portage des composants « use client » de la maquette.

   - ComportementsProduit.tsx : variantes (taille, coloris = autre fiche),
     offres 1 couette / Duo / Pack famille, coloris de chaque couette des packs,
     bloc « Inclus dans votre commande », barre d'achat collante et ses menus,
     reprise de la position après un changement depuis la barre, compte à
     rebours, ajout au panier ;
   - GalerieProduit.tsx : miniatures (téléphone) qui changent la grande photo ;
   - FaqProduit.tsx : un seul volet ouvert, signe + / − ;
   - CarrouselAvis.tsx : flèches qui s'éteignent aux extrémités ;
   - SectionFormule.tsx : cartes qui se déplient une à une.

   Les mécaniques Swiper et accordéons de ComportementsProduit.tsx qui visent des
   éléments absents de la fiche (galerie Swiper, .content-list-slider,
   .t-accordion__item, panneaux d'achat) ne sont pas reprises : elles n'agissent
   sur rien dans la maquette non plus.

   Ajout au panier (contrat du tiroir panier, voir CONVENTIONS.md) :
   1 couette -> Whoosh.ajouter([{ id, quantity: 1 }]) ; Duo / Pack famille ->
   une ligne par couette (variante du coloris choisi), propriétés cachées
   _pack (titre de l'offre) et _pack_id (identifiant unique de l'ajout).

   Ce fichier est chargé par plusieurs sections : il ne s'installe qu'une fois. */
(function () {
  "use strict";
  if (window.WhProduit) return;
  var W = (window.WhProduit = {});
  var montes = []; // { el, nettoyer }

  function ecouter(el, type, fn, liste, options) {
    el.addEventListener(type, fn, options);
    liste.push(function () {
      el.removeEventListener(type, fn, options);
    });
  }
  function tous(racine, selecteur) {
    return Array.prototype.slice.call(racine.querySelectorAll(selecteur));
  }

  /* ------------------------------------------------------------------------
     Haut de fiche : section#section-product-showcase-pdp
     ------------------------------------------------------------------------ */
  function fiche(scope) {
    var nettoyages = [];
    /* La maquette pose l'offre choisie sur .tpl-manukora (data-wh-offre). */
    var racine = scope.closest(".tpl-manukora") || scope;
    var donnees = {};
    var bloc = scope.parentNode && scope.parentNode.parentNode
      ? scope.parentNode.parentNode.querySelector("script[data-wh-produit-donnees]")
      : null;
    if (!bloc) bloc = document.querySelector("script[data-wh-produit-donnees]");
    try {
      donnees = JSON.parse(bloc ? bloc.textContent : "{}");
    } catch (e) {
      donnees = {};
    }

    /* --- Galerie : miniatures ------------------------------------------- */
    var principale = scope.querySelector(".tpl-galerie__principale img");
    /* Visuels de vente du téléphone (voir wh-produit.liquid) : sur téléphone,
       la grande photo affiche déjà l'affiche via <source> ; on la passe dans src
       pour que les miniatures et le glissement puissent changer la photo. Sur
       ordinateur, leurs miniatures sont retirées et la galerie reste celle d'avant. */
    var source = scope.querySelector(".tpl-galerie__principale source");
    /* 02/11 : fiches à visuels de vente (tpl-galerie--ventes) : même carrousel sur ordinateur, façon NUORO. */
    if (scope.querySelector(".tpl-galerie--ventes") || (window.matchMedia && window.matchMedia("(max-width: 749px)").matches)) {
      if (source && principale) {
        principale.setAttribute("src", source.getAttribute("srcset"));
        source.parentNode.removeChild(source);
      }
      /* photos réservées à l'ordinateur (data-wh-ordi) : retirées du carrousel */
      var minisOrdi = tous(scope, ".tpl-galerie__miniature[data-wh-ordi]");
      if (minisOrdi.length) {
        minisOrdi.forEach(function (b) { b.parentNode.removeChild(b); });
        if (!scope.querySelector(".tpl-galerie__miniature--active")) {
          var p1 = scope.querySelector(".tpl-galerie__miniature");
          if (p1) {
            p1.classList.add("tpl-galerie__miniature--active");
            p1.setAttribute("aria-pressed", "true");
            var im1 = p1.querySelector("img");
            if (principale && im1) principale.setAttribute("src", p1.getAttribute("data-wh-grand") || im1.getAttribute("src") || im1.getAttribute("data-wh-src"));
          }
        }
      }
    } else {
      var minisTel = tous(scope, ".tpl-galerie__miniature[data-wh-mobile]");
      if (minisTel.length) {
        minisTel.forEach(function (b) { b.parentNode.removeChild(b); });
        var premiere = scope.querySelector(".tpl-galerie__miniature");
        if (premiere) {
          premiere.classList.add("tpl-galerie__miniature--active");
          premiere.setAttribute("aria-pressed", "true");
        }
      }
    }
    var miniatures = tous(scope, ".tpl-galerie__miniature");

    miniatures.forEach(function (bouton) {
      ecouter(bouton, "click", function () {
        miniatures.forEach(function (b) {
          var actif = b === bouton;
          b.classList.toggle("tpl-galerie__miniature--active", actif);
          b.setAttribute("aria-pressed", actif ? "true" : "false");
        });
        var img = bouton.querySelector("img");
        /* data-wh-grand : image pleine qualité ; la miniature, elle, est une petite version (02/11). */
        if (principale && img) principale.setAttribute("src", bouton.getAttribute("data-wh-grand") || img.getAttribute("src") || img.getAttribute("data-wh-src"));
      }, nettoyages);
    });

    /* 02/11 : galerie de vente plus haute que l'écran (ordinateur) : on l'accroche
       plus haut pour que la rangée de miniatures reste visible en descendant. */
    var colonne = scope.querySelector(".product-showcase__gallery");
    if (colonne && scope.querySelector(".tpl-galerie--ventes")) {
      var hautAccroche = parseFloat(getComputedStyle(colonne).top) || 100;
      var caler = function () {
        colonne.style.top = "";
        if (getComputedStyle(colonne).position !== "sticky") return;
        colonne.style.top = Math.min(hautAccroche, window.innerHeight - colonne.offsetHeight - 24) + "px";
      };
      caler();
      ecouter(window, "resize", caler, nettoyages);
    }

    /* --- Galerie : glisser la grande photo au doigt (téléphone) ---------
       Carrousel : la photo voisine est collée à côté de la photo affichée et
       les deux suivent le doigt. Au-delà de 50 px, elles finissent de glisser
       et la voisine prend la place ; sinon elles reviennent. La miniature
       active suit et reste visible dans sa rangée. Aux extrémités, la photo
       résiste puis revient. Le défilement vertical de la page reste libre. */
    var cadre = scope.querySelector(".tpl-galerie__principale");
    var rangee = scope.querySelector(".tpl-galerie__miniatures");
    if (cadre && principale && miniatures.length > 1) {
      cadre.style.touchAction = "pan-y";
      cadre.style.overflow = "hidden";
      if (getComputedStyle(cadre).position === "static") cadre.style.position = "relative";
      var depart = null;
      var ecart = 0;
      var sensGeste = null; // "x" : on glisse la photo, "y" : la page défile
      var voisine = null; // { img, index, cote : 1 à droite, -1 à gauche }
      var occupe = false;
      var prechargees = false;
      var GLISSE = "transform .26s cubic-bezier(.22,.61,.36,1)";
      var indexActif = function () {
        for (var i = 0; i < miniatures.length; i++) {
          if (miniatures[i].classList.contains("tpl-galerie__miniature--active")) return i;
        }
        return 0;
      };
      var srcDe = function (i) {
        var im = miniatures[i].querySelector("img");
        return miniatures[i].getAttribute("data-wh-grand") || (im ? im.getAttribute("src") || im.getAttribute("data-wh-src") : "");
      };
      var precharger = function () {
        if (prechargees) return;
        prechargees = true;
        miniatures.forEach(function (b, i) {
          var src = srcDe(i);
          if (src) new Image().src = src;
        });
      };
      var largeur = function () {
        return principale.offsetWidth || cadre.clientWidth || 300;
      };
      var retirerVoisine = function () {
        if (voisine && voisine.img.parentNode) voisine.img.parentNode.removeChild(voisine.img);
        voisine = null;
      };
      var preparerVoisine = function (index, cote) {
        if (voisine && voisine.index === index) return;
        retirerVoisine();
        var img = document.createElement("img");
        img.src = srcDe(index);
        img.alt = "";
        img.setAttribute("aria-hidden", "true");
        var s = img.style;
        s.position = "absolute";
        s.left = principale.offsetLeft + "px";
        s.top = principale.offsetTop + "px";
        s.width = principale.offsetWidth + "px";
        s.height = principale.offsetHeight + "px";
        s.objectFit = getComputedStyle(principale).objectFit || "cover";
        s.borderRadius = getComputedStyle(principale).borderRadius;
        s.pointerEvents = "none";
        cadre.appendChild(img);
        voisine = { img: img, index: index, cote: cote };
      };
      var placer = function (x, animer) {
        var t = animer ? GLISSE : "none";
        principale.style.transition = t;
        principale.style.transform = x ? "translateX(" + x + "px)" : "";
        if (voisine) {
          voisine.img.style.transition = t;
          voisine.img.style.transform = "translateX(" + (x + voisine.cote * largeur()) + "px)";
        }
      };
      var montrerMiniature = function (bouton) {
        if (!rangee) return;
        var gauche = bouton.offsetLeft - (rangee.clientWidth - bouton.offsetWidth) / 2;
        rangee.scrollTo({ left: Math.max(0, gauche), behavior: "smooth" });
      };
      var terminer = function (cible) {
        occupe = true;
        placer(-voisine.cote * largeur(), true);
        setTimeout(function () {
          miniatures[cible].click();
          montrerMiniature(miniatures[cible]);
          var remettre = function () {
            principale.style.transition = "none";
            principale.style.transform = "";
            retirerVoisine();
            occupe = false;
          };
          if (principale.decode) principale.decode().then(remettre, remettre);
          else remettre();
        }, 270);
      };
      var annuler = function () {
        occupe = true;
        placer(0, true);
        setTimeout(function () {
          retirerVoisine();
          occupe = false;
        }, 270);
      };
      ecouter(cadre, "touchstart", function (e) {
        if (e.touches.length !== 1 || occupe) return;
        precharger();
        depart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        ecart = 0;
        sensGeste = null;
      }, nettoyages, { passive: true });
      ecouter(cadre, "touchmove", function (e) {
        if (!depart) return;
        var dx = e.touches[0].clientX - depart.x;
        var dy = e.touches[0].clientY - depart.y;
        if (!sensGeste && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) sensGeste = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        if (sensGeste !== "x") return;
        var i = indexActif();
        var cible = dx < 0 ? i + 1 : i - 1;
        if (cible >= 0 && cible < miniatures.length) {
          preparerVoisine(cible, dx < 0 ? 1 : -1);
          ecart = dx;
        } else {
          retirerVoisine();
          ecart = dx / 3;
        }
        placer(ecart, false);
      }, nettoyages, { passive: true });
      var finir = function () {
        if (!depart) return;
        depart = null;
        if (sensGeste !== "x") return;
        if (voisine && Math.abs(ecart) > 50) terminer(voisine.index);
        else annuler();
      };
      ecouter(cadre, "touchend", finir, nettoyages);
      ecouter(cadre, "touchcancel", finir, nettoyages);
    }

    /* --- Variantes : chaque taille est une autre fiche ------------------ */
    tous(scope, ".product-variants").forEach(function (groupe) {
      var options = tous(groupe, ".product-variants__option").filter(function (o) {
        return !o.classList.contains("product-variants__option--link");
      });
      var libelle = groupe.querySelector(".product-variants__selected");
      options.forEach(function (option) {
        var bouton = option.querySelector(".product-variants__option-button") || option;
        ecouter(bouton, "click", function (e) {
          e.preventDefault();
          var url = bouton.getAttribute("data-url");
          if (url) {
            window.location.assign(url);
            return;
          }
          options.forEach(function (o) {
            o.classList.remove("product-variants__option--active");
          });
          option.classList.add("product-variants__option--active");
          if (libelle) {
            var texte = option.querySelector(".product-variants__option-button--text--text");
            var brut = ((texte && texte.textContent) || option.textContent || "").trim();
            if (brut) libelle.textContent = brut;
          }
        }, nettoyages);
      });
    });

    /* --- Coloris : chaque coloris est une autre fiche -------------------- */
    tous(scope, ".variant-products").forEach(function (liste) {
      var produits = tous(liste, ".variant-product");
      produits.forEach(function (produit) {
        var bouton = produit.querySelector(".variant-product__button") || produit;
        ecouter(bouton, "click", function (e) {
          e.preventDefault();
          var url = bouton.getAttribute("data-url");
          if (url) {
            window.location.assign(url);
            return;
          }
          produits.forEach(function (p) {
            p.classList.remove("variant-product-selected");
          });
          produit.classList.add("variant-product-selected");
        }, nettoyages);
      });
    });

    /* --- Offres (1 couette / duo / pack famille) ------------------------- */
    var cartesOffre = tous(scope, "[data-wh-offre]");
    var chiffre = function (t) {
      /* « 189,80 € » → 189.8 : la virgule est la décimale. */
      return Number(String(t || "").replace(/[^0-9,]/g, "").replace(",", ".")) || 0;
    };
    var euros = function (v) {
      v = Math.round(v * 100) / 100;
      return v.toLocaleString("fr-FR", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }) + " €";
    };
    cartesOffre.forEach(function (carte) {
      ecouter(carte, "click", function (e) {
        e.preventDefault();
        cartesOffre.forEach(function (c) {
          c.classList.toggle("wh-offres__carte--active", c === carte);
          c.setAttribute("aria-pressed", c === carte ? "true" : "false");
        });
        var prix = carte.getAttribute("data-prix") || "";
        var prixBarre = carte.getAttribute("data-prix-barre") || "";
        var troisFois = carte.getAttribute("data-trois-fois") || "";
        tous(scope, '[data-wh-prix="actuel"]').forEach(function (n) { n.textContent = prix; });
        tous(scope, '[data-wh-prix="barre"]').forEach(function (n) { n.textContent = prixBarre; });
        tous(scope, '[data-wh-prix="troisfois"]').forEach(function (n) { n.textContent = troisFois; });
        var id = carte.getAttribute("data-wh-offre") || "";
        racine.setAttribute("data-wh-offre", id === "unite" ? "" : carte.getAttribute("data-titre") || "");
        /* Packs : le coloris de chaque couette s'ouvre dans la carte choisie, et
           le choix du coloris en haut de fiche disparaît. */
        var avant = carte.getBoundingClientRect().top;
        var pack = false;
        tous(scope, "[data-wh-pack]").forEach(function (g) {
          var actif = g.getAttribute("data-wh-pack") === id;
          g.hidden = !actif;
          var item = g.closest(".wh-offres__item");
          if (item) item.classList.toggle("wh-offres__item--ouvert", actif);
          if (actif) pack = true;
        });
        /* Ce qui est inclus : la liste s'ouvre sous la carte choisie. */
        tous(scope, "[data-wh-inclus]").forEach(function (g) { g.hidden = g.getAttribute("data-wh-inclus") !== id; });
        tous(scope, ".wh-offres__item").forEach(function (it) { it.classList.toggle("wh-offres__item--ouvert", it.contains(carte)); });
        tous(scope, "[data-wh-coloris-bloc]").forEach(function (b) { b.hidden = pack; });
        tous(document, "[data-wh-barre-coloris]").forEach(function (b) { b.hidden = pack; });
        /* La carte touchée reste sous le doigt quand le bloc du dessus disparaît. */
        var decalage = carte.getBoundingClientRect().top - avant;
        if (decalage) window.scrollBy(0, decalage);
        tous(scope, "[data-wh-offre-titre]").forEach(function (n) {
          n.textContent = carte.getAttribute("data-titre") || "";
        });
        tous(document, "[data-wh-barre-offre]").forEach(function (o) {
          o.classList.toggle("wh-barre-option--active", o.getAttribute("data-wh-barre-offre") === id);
        });
        /* « Inclus dans votre commande » : quantités et valeurs suivent le
           nombre de couettes de l'offre. */
        var bonus = scope.querySelector("[data-wh-bonus]");
        if (bonus) {
          var n = Number(carte.getAttribute("data-nombre") || "1");
          var valeurCouettes = chiffre(carte.getAttribute("data-valeur") || prixBarre || prix);
          tous(bonus, "[data-wh-bonus-couettes]").forEach(function (el) { el.textContent = String(n); });
          tous(bonus, "[data-wh-bonus-valeur-couette]").forEach(function (el) { el.textContent = euros(valeurCouettes); });
          tous(bonus, "[data-wh-bonus-qte]").forEach(function (el) {
            var q = Number(el.getAttribute("data-wh-bonus-qte")) * n;
            el.textContent = String(q);
            var lib = el.parentElement ? el.parentElement.querySelector("[data-singulier]") : null;
            if (lib) lib.textContent = (q > 1 ? lib.getAttribute("data-pluriel") : lib.getAttribute("data-singulier")) || "";
          });
          var total = valeurCouettes;
          tous(bonus, "[data-wh-bonus-valeur]").forEach(function (el) {
            var v = Number(el.getAttribute("data-wh-bonus-valeur")) * (el.getAttribute("data-par-couette") === "1" ? n : 1);
            el.textContent = euros(v);
            total += v;
          });
          tous(bonus, "[data-wh-bonus-total]").forEach(function (el) { el.textContent = euros(total); });
          tous(bonus, "[data-wh-bonus-economie]").forEach(function (el) { el.textContent = euros(total - chiffre(prix)); });
        }
      }, nettoyages);
    });

    /* --- Packs : un coloris par couette ---------------------------------- */
    tous(scope, "[data-wh-pack-ligne]").forEach(function (ligne) {
      var pastilles = tous(ligne, ".wh-pack__pastille");
      pastilles.forEach(function (p) {
        ecouter(p, "click", function (e) {
          e.preventDefault();
          pastilles.forEach(function (x) {
            x.classList.toggle("wh-pack__pastille--active", x === p);
            x.setAttribute("aria-checked", x === p ? "true" : "false");
          });
        }, nettoyages);
      });
    });

    /* --- Barre d'achat collante ------------------------------------------ */
    /* Elle glisse depuis le bas dès que le bouton d'achat est passé au-dessus de
       l'écran, et se retire en remontant jusqu'à lui ou quand le pied de page
       entre à l'écran. */
    var barre = scope.querySelector("#sticky-add-to-cart");
    var boutonPrincipal = scope.querySelector("#ps-add-to-cart");
    if (barre && boutonPrincipal) {
      var majBarre = function () {
        var pied = document.querySelector(".wh-pied");
        var piedVisible = !!pied && pied.getBoundingClientRect().top < window.innerHeight;
        var montrer = boutonPrincipal.getBoundingClientRect().bottom < 0 && !piedVisible;
        barre.classList.toggle("show", montrer);
        if (!montrer) tous(barre, ".sticky-add-to-cart__dropdown.open").forEach(function (m) { m.classList.remove("open"); });
      };
      majBarre();
      ecouter(window, "scroll", majBarre, nettoyages, { passive: true });
      ecouter(window, "resize", majBarre, nettoyages);
      var boutonBarre = barre.querySelector(".sticky-add-to-cart__button");
      if (boutonBarre) {
        ecouter(boutonBarre, "click", function (e) {
          e.preventDefault();
          boutonPrincipal.click();
        }, nettoyages);
      }

      /* Menus de la barre : un à la fois ; clic ailleurs ou Échap le referme. */
      var menus = tous(barre, ".sticky-add-to-cart__dropdown");
      var fermer = function () {
        menus.forEach(function (m) {
          m.classList.remove("open");
          var b = m.querySelector(".sticky-add-to-cart__dropdown-toggle");
          if (b) b.setAttribute("aria-expanded", "false");
        });
      };
      menus.forEach(function (menu) {
        var bascule = menu.querySelector(".sticky-add-to-cart__dropdown-toggle");
        if (!bascule) return;
        bascule.setAttribute("aria-expanded", "false");
        ecouter(bascule, "click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var ouvrir = !menu.classList.contains("open");
          fermer();
          if (ouvrir) {
            menu.classList.add("open");
            bascule.setAttribute("aria-expanded", "true");
          }
        }, nettoyages);
      });
      ecouter(document, "click", function (e) {
        if (!barre.contains(e.target)) fermer();
      }, nettoyages);
      ecouter(document, "keydown", function (e) {
        if (e.key === "Escape") fermer();
      }, nettoyages);

      tous(barre, "[data-wh-barre-offre]").forEach(function (option) {
        ecouter(option, "click", function (e) {
          e.preventDefault();
          var cible = scope.querySelector('[data-wh-offre="' + option.getAttribute("data-wh-barre-offre") + '"]');
          if (cible) cible.click();
          fermer();
        }, nettoyages);
      });

      /* Taille et coloris ouvrent l'autre fiche en gardant la position dans la
         page et l'offre choisie. */
      tous(barre, "[data-wh-barre-url]").forEach(function (option) {
        ecouter(option, "click", function (e) {
          e.preventDefault();
          if (option.classList.contains("wh-barre-option--active")) {
            fermer();
            return;
          }
          var active = scope.querySelector(".wh-offres__carte--active");
          var offre = active ? active.getAttribute("data-wh-offre") || "" : "";
          try {
            sessionStorage.setItem("wh-reprise", JSON.stringify({ y: window.scrollY, offre: offre }));
          } catch (err) {}
          window.location.assign(option.getAttribute("data-wh-barre-url") || "");
        }, nettoyages);
      });
    }

    /* Retour d'un changement de taille ou de coloris fait depuis la barre :
       même offre, même position dans la page. */
    try {
      var brut = sessionStorage.getItem("wh-reprise");
      if (brut) {
        var reprise = JSON.parse(brut) || {};
        if (reprise.offre) {
          var carteReprise = scope.querySelector('[data-wh-offre="' + reprise.offre + '"]');
          if (carteReprise) carteReprise.click();
        }
        if (typeof reprise.y === "number") {
          var etapes = [0, 120, 350, 800];
          var minuteries = etapes.map(function (t, i) {
            return window.setTimeout(function () {
              window.scrollTo(0, reprise.y);
              if (i === etapes.length - 1) {
                try { sessionStorage.removeItem("wh-reprise"); } catch (err) {}
              }
            }, t);
          });
          nettoyages.push(function () {
            minuteries.forEach(function (m) { window.clearTimeout(m); });
          });
        } else {
          sessionStorage.removeItem("wh-reprise");
        }
      }
    } catch (err) {}

    /* --- Compte à rebours de l'offre Duo (date de fin réelle) --- */
    /* Même échéance pour tout le monde (data-fin, en secondes). La barre suit la part de
       l'offre déjà écoulée ; à l'échéance, le bloc disparaît. */
    var tempsRestant = scope.querySelector("[data-compte-a-rebours]");
    if (tempsRestant) {
      var fin = Number(tempsRestant.getAttribute("data-fin")) * 1000;
      var debut = Number(tempsRestant.getAttribute("data-debut")) * 1000;
      var barre = scope.querySelector("[data-wh-offre-barre]");
      var deux = function (n) { return String(n).padStart(2, "0"); };
      var minuterie = null;
      var majCompte = function () {
        var maintenant = Date.now();
        var reste = Math.floor((fin - maintenant) / 1000);
        if (!fin || reste <= 0) {
          tous(scope, "[data-wh-offre-bloc]").forEach(function (el) { el.hidden = true; el.style.display = "none"; });
          if (minuterie) window.clearInterval(minuterie);
          return;
        }
        var jours = Math.floor(reste / 86400);
        reste = reste % 86400;
        tempsRestant.textContent = (jours > 0 ? jours + " j " : "") + deux(Math.floor(reste / 3600)) + ":" + deux(Math.floor((reste % 3600) / 60)) + ":" + deux(reste % 60);
        if (barre && fin > debut) {
          var part = Math.min(100, Math.max(0, (maintenant - debut) / (fin - debut) * 100));
          barre.style.width = part.toFixed(1) + "%";
        }
      };
      majCompte();
      minuterie = window.setInterval(majCompte, 1000);
      nettoyages.push(function () { window.clearInterval(minuterie); });
    }

    /* --- Questions fréquentes : un seul volet ouvert -------------------- */
    var volets = tous(scope, ".tpl-faq-produit__volet");
    var fermerVolet = function (volet) {
      var entete = volet.querySelector(".tpl-faq-produit__entete");
      var reponse = volet.querySelector(".tpl-faq-produit__reponse");
      if (reponse) reponse.parentNode.removeChild(reponse);
      if (entete) {
        entete.setAttribute("aria-expanded", "false");
        var signe = entete.querySelector(".tpl-faq-produit__signe");
        if (signe) signe.textContent = "+";
      }
    };
    volets.forEach(function (volet) {
      var entete = volet.querySelector(".tpl-faq-produit__entete");
      var modele = volet.querySelector("template");
      if (!entete || !modele) return;
      ecouter(entete, "click", function () {
        var ouverte = entete.getAttribute("aria-expanded") === "true";
        volets.forEach(fermerVolet);
        if (ouverte) return;
        entete.parentNode.insertBefore(modele.content.cloneNode(true), entete.nextSibling);
        entete.setAttribute("aria-expanded", "true");
        var signe = entete.querySelector(".tpl-faq-produit__signe");
        if (signe) signe.textContent = "−";
      }, nettoyages);
    });

    /* --- Ajout au panier -------------------------------------------------- */
    tous(scope, ".button-primary").forEach(function (bouton) {
      ecouter(bouton, "click", function (e) {
        e.preventDefault();
        /* Barre de chargement sous le libellé, le temps de l'ajout. */
        bouton.classList.add("is-loading");
        window.setTimeout(function () { bouton.classList.remove("is-loading"); }, 700);

        var active = scope.querySelector(".wh-offres__carte--active");
        var offre = active ? active.getAttribute("data-wh-offre") : "unite";
        var compositions = donnees.packs || {};
        var items = [];
        var groupe = offre && offre !== "unite" ? scope.querySelector('[data-wh-pack="' + offre + '"]') : null;
        if (groupe && compositions[offre]) {
          var nomPack = active.getAttribute("data-titre") || "";
          var packId = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
          var parId = {};
          tous(groupe, "[data-wh-pack-ligne]").forEach(function (ligne, i) {
            var taille = compositions[offre][i];
            var choix = ligne.querySelector(".wh-pack__pastille--active") || ligne.querySelector(".wh-pack__pastille");
            var parTaille = (donnees.variantes || {})[taille] || {};
            var id = choix ? parTaille[choix.getAttribute("data-nom")] : null;
            if (!id) return;
            if (parId[id]) {
              parId[id].quantity += 1;
            } else {
              parId[id] = { id: id, quantity: 1, properties: { _pack: nomPack, _pack_id: packId } };
              items.push(parId[id]);
            }
          });
        } else if (donnees.variante) {
          items.push({ id: donnees.variante, quantity: 1 });
        }
        if (!items.length) return;
        if (window.Whoosh && typeof window.Whoosh.ajouter === "function") {
          window.Whoosh.ajouter(items);
        } else {
          window.dispatchEvent(new CustomEvent("tpl-panier:ajouter", { detail: { items: items } }));
        }
      }, nettoyages);
    });

    return function () {
      nettoyages.forEach(function (fn) { fn(); });
    };
  }

  /* ------------------------------------------------------------------------
     Carrousel d'avis en vidéo (.tpl-carrousel)
     ------------------------------------------------------------------------ */
  function carrousel(section) {
    var nettoyages = [];
    var piste = section.querySelector(".tpl-carrousel__piste");
    var fleches = tous(section, ".tpl-carrousel__fleche");
    if (!piste || fleches.length < 2) return function () {};
    /* Les flèches s'éteignent aux extrémités. */
    var jauger = function () {
      fleches[0].disabled = piste.scrollLeft <= 1;
      fleches[1].disabled = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 1;
    };
    jauger();
    ecouter(piste, "scroll", jauger, nettoyages, { passive: true });
    ecouter(window, "resize", jauger, nettoyages);
    var glisser = function (sens) {
      var carte = piste.querySelector(".tpl-carrousel__carte");
      var pas = carte ? carte.offsetWidth + 16 : piste.clientWidth;
      piste.scrollBy({ left: pas * sens, behavior: "smooth" });
    };
    ecouter(fleches[0], "click", function () { glisser(-1); }, nettoyages);
    ecouter(fleches[1], "click", function () { glisser(1); }, nettoyages);
    return function () {
      nettoyages.forEach(function (fn) { fn(); });
    };
  }

  /* ------------------------------------------------------------------------
     « Trois raisons » (.tpl-formule) : une carte ouverte à la fois
     ------------------------------------------------------------------------ */
  function formule(section) {
    var nettoyages = [];
    var cartes = tous(section, ".tpl-formule__carte");
    var refermer = function (carte) {
      var bouton = carte.querySelector(".tpl-formule__bascule");
      var detail = carte.querySelector(".tpl-formule__carte-detail");
      var titre = carte.querySelector(".tpl-formule__carte-titre");
      carte.classList.remove("est-ouverte");
      if (detail) detail.parentNode.removeChild(detail);
      if (bouton) {
        bouton.setAttribute("aria-expanded", "false");
        bouton.setAttribute("aria-label", "Déplier " + (titre ? titre.textContent : ""));
        var trait = bouton.querySelector("path");
        if (trait) trait.style.transform = "none";
      }
    };
    cartes.forEach(function (carte) {
      var bouton = carte.querySelector(".tpl-formule__bascule");
      var modele = carte.querySelector("template");
      var texte = carte.querySelector(".tpl-formule__carte-texte");
      var titre = carte.querySelector(".tpl-formule__carte-titre");
      if (!bouton || !modele) return;
      ecouter(bouton, "click", function () {
        var ouverte = carte.classList.contains("est-ouverte");
        cartes.forEach(refermer);
        if (ouverte) return;
        carte.classList.add("est-ouverte");
        var detail = modele.content.cloneNode(true);
        if (texte && texte.nextSibling) carte.insertBefore(detail, texte.nextSibling);
        else carte.insertBefore(detail, bouton);
        bouton.setAttribute("aria-expanded", "true");
        bouton.setAttribute("aria-label", "Replier " + (titre ? titre.textContent : ""));
        var trait = bouton.querySelector("path");
        if (trait) trait.style.transform = "rotate(45deg)";
      }, nettoyages);
    });
    return function () {
      cartes.forEach(refermer);
      nettoyages.forEach(function (fn) { fn(); });
    };
  }

  /* ------------------------------------------------------------------------
     Montage, et éditeur de thème (sections redessinées)
     ------------------------------------------------------------------------ */
  var MODULES = [
    ["#section-product-showcase-pdp", fiche],
    [".tpl-carrousel", carrousel],
    [".tpl-formule", formule]
  ];

  function monter(racine) {
    MODULES.forEach(function (m) {
      var elements = tous(racine, m[0]);
      if (racine.matches && racine.matches(m[0])) elements.unshift(racine);
      elements.forEach(function (el) {
        for (var i = 0; i < montes.length; i++) if (montes[i].el === el) return;
        montes.push({ el: el, nettoyer: m[1](el) || function () {} });
      });
    });
  }

  function demonter(racine) {
    montes = montes.filter(function (m) {
      if (racine !== m.el && !racine.contains(m.el)) return true;
      m.nettoyer();
      return false;
    });
  }

  W.monter = monter;
  W.demonter = demonter;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { monter(document); });
  } else {
    monter(document);
  }
  document.addEventListener("shopify:section:load", function (e) { monter(e.target); });
  document.addEventListener("shopify:section:unload", function (e) { demonter(e.target); });
})();
